import React from 'react';
import { Icon } from '../../icon/Icon';
import { Icons } from '../../icon/icons/material';
import { IconStyles, IconTheme } from '../../icon/Icon.types';
import styles from './FilterChipSet.module.scss';

type ChipSetProps = {
    chips: { id: string; label: string; }[];
    onRemoveItem?: (id: string) => void;
};

const FilterChipSet: React.FC<ChipSetProps> = ({ chips, onRemoveItem }) => (
    <div className="df-chip-set">
        {chips.map((chip) => (
            <div className="df-chip filter" id={`filter-chip-${chip.id}`} key={chip.id}>
                <span className="label">{chip.label}</span>
                <Icon.Base
                    className={styles['remove-chip-icon']}
                    title='Remove item'
                    size={18}
                    iconName={Icons.clear}
                    iconStyle={IconStyles.outlined}
                    theme={IconTheme.inherit}
                    onClick={onRemoveItem ? () => onRemoveItem(chip.id) : undefined}
                />
            </div>
        ))}
    </div>
);

export default FilterChipSet;
